export default __webpack_public_path__ + "static/media/2422.1c42f238.png";